<template>
    <div v-if="pgLoading" class="loadingLogo">
        <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
    </div>
    <div v-else class="">

        <Banner :background="(info.image) ? info.image.url : ''" :title="(!pgLoading) ? $t('app.gallery') : ''"
            :subtitle="(!pgLoading) ? $t('app.gallery') : ''">
        </Banner>

        <section class="gallery-area pt-50 pb-50">
            <div class="container">

                <div class="gallery-area pt-100 pb-70" :class="(locale == 'ar') ? 'rtl' : 'ltr'" style='display:none'>
                    <div v-if="pgLoading" class="section-title webkit-ml20per">
                        <div class="webkit-animation webkit-100-240"></div>
                    </div>

                    <div v-if="!pgLoading" class="section-title">
                        <span>
                            <i class="bx bx-images"></i>
                            {{ $t('gallery.title') }}
                        </span>
                        <h2 class="font-deco mb-3">
                            {{ info.title }}
                        </h2>
                        <p v-html="info.body"></p>
                    </div>
                </div>

                <div class="row mb-5 mt-4">
                    <div class="col-12 text-center filter-container">
                        <button class="filter-btn" :class="selectedCategoryId === '' ? 'active' : ''"
                            @click="selectCategory('')">
                            {{ $t('projects.all') || 'All' }}
                        </button>

                        <button v-for="cat in categories" :key="cat.id" class="filter-btn"
                            :class="selectedCategoryId === cat.id ? 'active' : ''" @click="selectCategory(cat.id)">
                            {{ locale == 'ar' && cat.ar ? cat.ar.title : (cat.en ? cat.en.title : cat.title) }}
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div v-for="(row, index) in rows" :key="index" class="col-6 col-xl-4 col-lg-3 col-md-6 mb-4">

                        <div class="gallery-card pos-rel text-center wow fadeInUp2 animated" data-wow-delay=".3s">
                            <div class="gallery__thumb pos-rel">
                                <img :src="row.thumb" :alt="row.title" class="gallery-img" loading="lazy" />

                                <div class="gallery__overlay">
                                    <a class="popup-image" href="javascript:;" @click="openGallery(index)"
                                        data-imagelightbox="popup-btn">
                                        <div class="icon-wrapper">
                                            <i class="far fa-plus"></i>
                                        </div>
                                        <h3>{{ row.caption }}</h3>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <LightBox ref="lightbox" :media="rows" :show-caption="true" :show-light-box="false">
                        </LightBox>

                    </div>
                </div>

                <Pagination v-if="!pgLoading && rows.length > 0" :currentPage="paginate.currentPage"
                    :itemsPerPage="paginate.itemsPerPage" :resultCount="paginate.resultCount"
                    :nextPage="paginate.nextPage" :prevPage="paginate.prevPage" v-on:pageChange="handlePageChange">
                </Pagination>
            </div>
        </section>

    </div>
</template>

<script>
import LightBox from '../lightbox/App.vue';

export default {
    name: 'Gallery',
    components: {
        Banner: () => import('@/components/Banner.vue'),
        Pagination: () => import('@/components/Pagination.vue'),
        LightBox,
    },
    data() {
        return {
            locale: 'ar',
            pgLoading: true,
            info: '',
            rows: [],
            categories: [],
            selectedCategoryId: '', // '' represents 'All'

            paginate: {
                currentPage: 1,
                itemsPerPage: 12,
                resultCount: 0,
                nextPage: 2,
                prevPage: 0,
            },
        }
    },
    created() {
        if (localStorage.getItem('locale')) {
            this.locale = localStorage.getItem('locale');
        }

        this.fetchCategories();
        this.fetchData();
    },
    methods: {
        fetchCategories() {
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest',
            };

            const options = {
                url: window.baseURL + '/gallery-categories',
                method: 'GET',
                params: {
                    locale: this.locale,
                    status: 'active',
                    paginate: 100
                }
            };

            this.$axios(options)
                .then(res => {
                    this.categories = res.data.rows || res.data;
                })
                .catch(err => console.error(err));
        },

        selectCategory(categoryId) {
            this.selectedCategoryId = categoryId;
            this.paginate.currentPage = 1;
            this.fetchData();
        },

        fetchData() {
            window.scrollTo(0, 0);
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest',
            };

            const options = {
                url: window.baseURL + '/galleries',
                method: 'GET',
                data: {},
                params: {
                    locale: this.locale,
                    status: 'active',
                    paginate: this.paginate.itemsPerPage,
                    page: this.paginate.currentPage,
                    gallery_category_id: this.selectedCategoryId
                }
            }

            this.$axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.rows = res.data.rows;

                    // info
                    this.info = res.data.info;

                    // paginate
                    this.paginate.currentPage = res.data.paginate.current_page;
                    this.paginate.resultCount = res.data.paginate.total;
                    this.paginate.nextPage = res.data.paginate.next_page;
                    this.paginate.prevPage = res.data.paginate.prev_page;
                })
                .catch(() => {
                    this.pgLoading = false;
                })
                .finally(() => { });
        },

        handlePageChange(event) {
            this.paginate.currentPage = event.currentPage;
            this.fetchData();
        },

        openGallery(index) {
            this.$refs.lightbox[index].showImage(index)
        },
    },
}
</script>

<style scoped>
/* Filter Buttons */
.filter-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
}

.filter-btn {
    background: #ffffff;
    color: #64748b;
    border: 2px solid #e2e8f0;
    padding: 8px 24px;
    border-radius: 50px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    outline: none;
}

.filter-btn:hover {
    border-color: #1f94d1;
    color: #1f94d1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
}

.filter-btn.active {
    background: #1f94d1;
    color: #ffffff;
    border-color: #1f94d1;
    box-shadow: 0 6px 15px rgba(79, 70, 229, 0.3);
    transform: translateY(-2px);
}

/* Gallery Cards */
.gallery-card {
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    height: 100%;
}

.gallery-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.gallery__thumb {
    position: relative;
    width: 100%;
    height: 320px;
    /* Fixed height for uniformity */
    overflow: hidden;
}

.gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Prevents image stretching */
    transition: transform 0.6s ease;
}

.gallery-card:hover .gallery-img {
    transform: scale(1.08);
    /* Beautiful slow zoom */
}

/* Hover Overlay */
.gallery__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.6);
    /* Dark tint */
    backdrop-filter: blur(3px);
    /* Glassmorphism effect */
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s ease;
}

.gallery-card:hover .gallery__overlay {
    opacity: 1;
    visibility: visible;
}

/* Overlay Content inside */
.popup-image {
    text-decoration: none !important;
    color: #ffffff !important;
    text-align: center;
    transform: translateY(20px);
    transition: all 0.4s ease;
}

.gallery-card:hover .popup-image {
    transform: translateY(0);
}

.icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #1f94d1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px auto;
    box-shadow: 0 4px 15px rgba(79, 70, 229, 0.5);
    transition: background 0.3s ease, transform 0.3s ease;
}

.icon-wrapper i {
    font-size: 20px;
    color: #fff;
}

.popup-image:hover .icon-wrapper {
    background: #4338ca;
    transform: scale(1.1);
}

.popup-image h3 {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    letter-spacing: 0.5px;
    color: #ffffff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Responsiveness adjustments */
@media (max-width: 768px) {
    .gallery__thumb {
        height: 250px;
    }
}

@media (max-width: 576px) {
    .filter-btn {
        padding: 6px 16px;
        font-size: 13px;
    }

    .gallery__thumb {
        height: 200px;
    }

    .icon-wrapper {
        width: 45px;
        height: 45px;
        margin-bottom: 10px;
    }

    .popup-image h3 {
        font-size: 15px;
    }
}
</style>